function getKlevuId() {
  let storeCountry = Shopify?.country;
  let storeLocale = Shopify?.locale;

  if (Shopify?.Checkout?.locale) {
    // In checkout
    [storeLocale, storeCountry] = Shopify.Checkout.locale.split("-");
  }

  if (!storeCountry || !storeLocale) {
    return null;
  }

  // "Others EN"
  const defaultKlevuId = "168786774545216505";

  const idMap = {
    // Germany
    "DE-DE": "168787189256516505",
    "EN-DE": "168776375205216505",
    // United Kingdom
    "EN-GB": "168786815478116505",
    // Switzerland
    "FR-CH": "168786857827616505",
    "EN-CH": "168786870638416505",
    "DE-CH": "168786878197616505",
    // Sweden
    "SV-SE": "168786892085116505",
    "EN-SE": "168786903454516505",
    // South Korea
    "EN-KR": "168786929831116505",
    // Norway
    "NO-NO": "168786970804716505",
    "EN-NO": "168786977822616505",
    // Austria
    "DE-AT": "168786987843216505",
    "EN-AT": "168787012150716505",
    // Denmark
    "DA-DK": "168787017822016505",
    "EN-DK": "168787024964116505",
    // France
    "FR-FR": "168787037003916505",
    "EN-FR": "168787031194616505",
  };

  const id =
    idMap[`${storeLocale.toUpperCase()}-${storeCountry.toUpperCase()}`];
  const key = id || defaultKlevuId;

  return "klevu-" + key;
}

export { getKlevuId };
